import { ref, watch, readonly } from 'vue'

// Global state to track which dropdown is currently open
const activeDropdownId = ref(null)

export function useDropdownManager() {
  const registerDropdown = (dropdownId) => {
    const isOpen = ref(false)
    
    const openDropdown = () => {
      // Close any other open dropdown
      if (activeDropdownId.value && activeDropdownId.value !== dropdownId) {
        // The other dropdown will automatically close due to reactive nature
      }
      activeDropdownId.value = dropdownId
      isOpen.value = true
    }
    
    const closeDropdown = () => {
      if (activeDropdownId.value === dropdownId) {
        activeDropdownId.value = null
      }
      isOpen.value = false
    }
    
    const toggleDropdown = () => {
      if (isOpen.value) {
        closeDropdown()
      } else {
        openDropdown()
      }
    }
    
    // Watch for changes to active dropdown
    watch(() => activeDropdownId.value, (newActiveId) => {
      if (newActiveId !== dropdownId && isOpen.value) {
        isOpen.value = false
      }
    })
    
    return {
      isOpen,
      openDropdown,
      closeDropdown,
      toggleDropdown
    }
  }
  
  const closeAllDropdowns = () => {
    activeDropdownId.value = null
  }
  
  return {
    registerDropdown,
    closeAllDropdowns,
    activeDropdownId: readonly(activeDropdownId)
  }
}
